import {
	InfiniteData,
	useInfiniteQuery,
	useQuery,
} from "@tanstack/react-query";
import {
	getFollowersCount,
	getHostList,
	getHostListV2,
	getUserOnboardingStatus,
	HostsListQueryFilter,
	HostsQueryFilter,
} from "@onair/services/host";
import { actionGetHostProfile } from "@onair/store/actions/host";
import {
	GET_FOLLOWERS_COUNT,
	GET_HOST_PROFILE,
	GET_HOST_LIST,
} from "../../keys";
import { FindManyFilter } from "@onair/types/extends";
import { User, Status, PageDto, UserDto } from "@onair/repositories";
import { isNull } from "lodash";
export const useGetFollowersCount = (
	hostId: string,
	options = { enabled: true },
) => {
	return useQuery({
		queryKey: [GET_FOLLOWERS_COUNT, hostId],
		queryFn: () => getFollowersCount(hostId),
		...options,
	});
};

export const useGetHostProfileByUsername = (
	{ username }: { username: string },
	options = { enabled: true },
) => {
	return useQuery({
		queryKey: [GET_HOST_PROFILE, username],
		queryFn: async () => {
			const query: FindManyFilter<User> = {
				include: {
					followers: true,
					followings: true,
					interests: true,
					categoriesV2: {
						where: {
							isDeleted: false,
							status: Status.ACTIVE,
						},
					},
					// categories: {
					// 	select: {
					// 		categoryId: true,
					// 		label: true,
					// 	},
					// },
					_count: {
						select: { events: true, followings: true, followers: true },
					},
				},
			};
			return await actionGetHostProfile(username, query);
		},
		enabled: options.enabled,
	});
};

export const useGetHostListQuery = (filter?: HostsQueryFilter) => {
	return useQuery({
		queryKey: [GET_HOST_LIST, filter],
		queryFn: () => getHostList(filter || {}),
	});
};

export const useInfinityGetHostListQuery = (filter: HostsListQueryFilter) => {
	return useInfiniteQuery<
		PageDto & {
			items?: UserDto[];
		},
		Error,
		InfiniteData<
			PageDto & {
				items?: UserDto[];
			},
			string | null
		>,
		(string | HostsListQueryFilter)[],
		string | null
	>({
		initialPageParam: null,
		queryKey: [GET_HOST_LIST, filter],
		queryFn: ({ pageParam }) =>
			getHostListV2({
				...filter,
				cursor: pageParam ?? undefined,
			}),
		getNextPageParam: (lastPage, pages) => lastPage.paging.nextCursor,
	});
};

export const useGetUserOnboardingStatusQuery = ({
	email,
	enabled,
}: {
	email?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ["getUserOnboardingStatus"],
		queryFn: () => getUserOnboardingStatus(email || ""),
		enabled,
	});
};
